module.exports = __webpack_public_path__ + "img/gigastore-on-finishline.44cf3e12.png";